export enum ETemperatureState {
  TransitionSteady = 0,
  Steady = 1,
  TransitionViolation = 2,
  Violation = 3,
}